import { auth } from '@onevision-resources/login';
import { WebSocketEventBus } from '@provision/ui-real-time-events';
import { useGlobalEventHubSubscription } from 'src/graphql/setup/hooks/use-event-hub-subscription';

const WS_URL = import.meta.env.VITE_WEBSOCKET_URL;

export const wsEventBus = new WebSocketEventBus({
  url: WS_URL,
  getCredentials: async () => {
    const token = await auth.getToken();
    return { token: `Bearer ${token}`, client: 'portal' };
  },
});

export const WebSocketConnection = () => {
  useGlobalEventHubSubscription(wsEventBus);

  return null;
};
